import Profile from "./Profile";

export default function Gallery(){
    return (
        <section>
            <h3> Amazing Scientists</h3>
            <Profile />
            <Profile />
            <Profile />
        </section>
    )
}